import { render, staticRenderFns } from "./mention-icon.vue?vue&type=template&id=c101168e"
import script from "./mention-icon.vue?vue&type=script&lang=js"
export * from "./mention-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports